<template>
  <v-container fluid>
      <v-row>
        <v-col>
         <v-row dense align="center"> 
             <v-col cols="auto" class="text-h3 gray--text">Cirurgia</v-col>
             <v-col cols="auto" class="ps-6"> 
             <authorization
              can="print"
              v-slot:default="{ authorization }">                                                                                                        
            <v-btn small icon v-bind="attrs" v-on="on" :disabled="printLoading" :loading="printLoading" @click="downloadSurgery" v-if="authorization || forcePrint">
              <v-icon>eva-printer-outline</v-icon>                                                                  
            </v-btn>
            </authorization>
            </v-col>
          </v-row>

          <TreatmentForm
            :treatment="treatment"
            :disabled="true"
            :key="treatmentId"
            v-if="treatment"
          />
        </v-col>

      <v-col cols="auto">
        <v-btn color="gray lighten-1" dark :to="`/prontuario/${attendance.id}/cirurgia`">
          voltar
        </v-btn>
      </v-col>

<v-col cols="auto">
        <EsignButton :esign="surgery.lastEsign" v-if="surgery" />
      </v-col>
    </v-row>

    <v-row v-if="surgery">
      <v-col>
        <v-tabs background-color="transparent" color="secondary">
          <v-tab to="detalhes">Detalhes</v-tab>
          <v-tab to="pre-operatorio">Pré-operatório</v-tab>
          <v-tab to="intra-operatorio">Intra-operatório</v-tab>
          <v-tab to="pos-operatorio">Pós-operatório</v-tab>
        </v-tabs>

        <router-view
          :surgery="surgery"
          :refreshSurgery="refreshSurgery"
          :surgeryMoment="surgeryMoment"
          :setSurgeryMoment="setSurgeryMoment"
          :disabled="signed"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "Surgery",
    props: {
      attendance: Object,
      surgeryId: String,
    },
    data() {
      return {
        printLoading: false,
        surgeryMoment: null,
        showSurgeryTherapyForm: false,
      };
    },
    apollo: {
      surgery: {
        query: require("@/graphql/surgery/surgery.gql"),
        variables() {
          return {
            surgeryId: this.surgeryId,
          };
        },
        pollInterval: 20000000,
      },
    },

    computed: {
      signed() {
        if (this.surgery) {
          return this.surgery.lastEsign.status !== "editable";
        }

        return false;
      },
    },
    methods: {
      refreshSurgery() {
        return this.$apollo.queries.surgery.refetch();
      },

      setSurgeryMoment(moment) {
        this.surgeryMoment = moment;
      },

      async generatePreview() {
        await this.apolloMutate({
          mutation: require("@/graphql/esign/generate_preview.gql"),

          variables: {
            esignId: this.surgery.lastEsign.id,
            dynamicForm: true,
            examAppraisal: true 
          },
        });
      },

      async downloadSurgery() {
        try {
          this.printLoading = true;

          await this.generatePreview();
          await this.refreshSurgery();

          const fileUrl = this.surgery.lastEsign.fileUrl;
          await window.open(`${process.env.VUE_APP_BASE_URL}${fileUrl}`, "_blank");

          this.printLoading = false;
        } catch (error) {
          console.log(error);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
